import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { Button } from '@hivebrite/design-system/Button';
import {
  FontAwesomeIcon,
  CATEGORIES,
} from '@hivebrite/design-system/FontAwesomeIcon';

import InputTitle from 'hb-builder/components/common/SettingsLibrary/SettingsDecoration/InputTitle';
import type { Config } from 'hb-builder/types';
import { downloadConfig } from 'hb-builder/utils/files';

const DownloadNetworkConfig = ({ config }: { config: Config }) => (
  <Wrapper>
    <InputTitle
      label={s__('Builder|Download Network config')}
      position="left"
    />
    <Button
      aria-label={s__('Builder|Download Network config')}
      icon={() => (
        <FontAwesomeIcon
          iconName="arrow-down-to-line"
          iconType={CATEGORIES.SOLID}
          height="12px"
        />
      )}
      onClick={() =>
        downloadConfig({
          config,
        })
      }
      variant="secondary"
    />
  </Wrapper>
);

export default DownloadNetworkConfig;

const Wrapper = styled(Box).attrs(() => ({
  alignItems: 'center',
  justifyContent: 'space-between',
  mb: 4,
  width: '100%',
}))``;
